import { buildBillingContext } from '@/apiCalls/billingContext';
import { postUrl } from '@/apiCalls/fetch';

import { IVehicleByPlateType } from './getVehicleByPlateTypes';

export async function getVehicleByPlate(
    plate: string | undefined,
    state: string | undefined,
    partner: string
): Promise<IVehicleByPlateType> {
    const url = `/api/asset/select/${partner}/plate/${state}/${plate}`;
    return postUrl<IVehicleByPlateType>(url, { billingContext: buildBillingContext() });
}
